import { createI18n } from 'vue-i18n';
import en from '@/lang/en.json';
import pt from '@/lang/pt_BR.json';

const i18n = createI18n({
  locale: localStorage.getItem('locale'),
  fallbackLocale: 'en',
  messages: {
    en,
    pt
  },
});

export default i18n;